export const InquiryLogPermissions = {
  GetAllInquiryLog: {
    permissionsId: "ac9ea80b-4a2c-4882-7950-08dcaf947ea8",
    permissionsName: "Get All Inquiry Log",
    description: null,
    componentsId: null,
    components: null,
  },
};
